import Papa from 'papaparse'

const REQUIRED_FIELDS = ['OldNameId', 'NewNameId']

const validator = (file) => {
  return new Promise((resolve) => {
    const requiredFields = REQUIRED_FIELDS
    let row = 0
    let headers = []
    Papa.parse(file, {
      worker: true,
      delimiter: ',',
      step: ({ data, errors }, parser) => {
        if (row === 0) {
          // check required headers are present
          for (const field of requiredFields) {
            const fieldMissing = !data.includes(field)
            if (fieldMissing) {
              console.debug('CSV Validation aborted')
              resolve({
                code: 'missing-field',
                message: `The CSV file must have the ${field} header`
              })
              parser.abort()
            }
          }
          headers = data
        } else {
          // skip empty rows
          const skip = data.every(v => !v?.trim())
          if (!skip) {
            data.forEach((value, idx) => {
              // check required attribues exist
              const isMissing = !value.trim()
              if (isMissing) {
                const field = headers[idx]
                const isRequired = requiredFields.includes(field)
                if (isRequired) {
                  console.debug('CSV Validation aborted')
                  resolve({
                    code: 'missing-attribute',
                    message: `The CSV file must have all ${field} records`
                  })
                  parser.abort()
                }
              }
            })
          }
        }
        row++
        if (errors.length) {
          console.debug('CSV Validation failed', errors)
          resolve({
            code: errors[0].code,
            message: errors[0].message
          })
          parser.abort()
        }
      },
      complete: () => {
        console.debug('CSV Validation complete')
        resolve(row)
      }
    })
  })
}

export default validator
